var _a;
window.MCEVENTS = {
  CART_ADDED: "mc:cart:added",
  CART_UPDATED: "mc:cart:updated",
  CART_ERROR: "mc:cart:error"
};
window.getShopifyRoot = function() {
  var _a2;
  const root = typeof Shopify !== "undefined" && ((_a2 = Shopify == null ? void 0 : Shopify.routes) == null ? void 0 : _a2.root) ? Shopify.routes.root : "/";
  return root.endsWith("/") ? root : `${root}/`;
};
window.theme = window.theme || {};
window.theme.settings = window.theme.settings || {};
const debugMode = ((_a = window.theme) == null ? void 0 : _a.settings) && typeof window.theme.settings.debug_mode !== "undefined" ? Number(window.theme.settings.debug_mode) : 0;
if (debugMode === 2) {
  const _dbg = "background:#6c757d;color:#fff;padding:1px 6px;border-radius:3px;font-weight:bold;font-size:11px;";
  const originalDispatch = window.dispatchEvent.bind(window);
  window.dispatchEvent = function(event) {
    console.groupCollapsed("%c GG %c \u{1F41E} window.dispatchEvent: " + event.type, _dbg, "");
    console.log("Evento:", event);
    console.log("Dettagli evento (event.detail):", event.detail);
    console.trace("Stack trace della chiamata a dispatchEvent");
    console.groupEnd();
    return originalDispatch(event);
  };
  console.log("%c GG %c \u{1F41E} Monitoraggio di window.dispatchEvent attivato", _dbg, "");
}
(function() {
  "use strict";
  const timers = /* @__PURE__ */ new Map();
  let openGroups = 0;
  const RESET = "";
  const _b = (bg) => `background:${bg};color:#fff;padding:1px 6px;border-radius:3px;font-weight:bold;font-size:11px;`;
  const BADGE = _b("#1a1a2e");
  const BADGE_DEBUG = _b("#6c757d");
  const BADGE_INFO = _b("#0d6efd");
  const BADGE_WARN = _b("#e67e22");
  const BADGE_SUCCESS = _b("#198754");
  const BADGE_ERROR = _b("#dc3545");
  const BADGE_TIME = _b("#6f42c1");
  const BADGE_GROUP = _b("#0891b2");
  const BADGE_TABLE = _b("#6366f1");
  const BADGE_TRACE = _b("#64748b");
  function getCallerInfo() {
    var _a2, _b2;
    try {
      const stack = new Error().stack || "";
      const line = (_b2 = (_a2 = stack.split("\n")[3]) == null ? void 0 : _a2.trim()) != null ? _b2 : "";
      const funcMatch = line.match(/^at\s+(?:new\s+)?([\w$.<>]+(?:\[as\s+[\w$.<>]+\])?)/);
      if (funcMatch == null ? void 0 : funcMatch[1]) {
        let caller = funcMatch[1];
        const fileMatch2 = line.match(/\(([^)]+:\d+:\d+)\)/);
        if (fileMatch2 == null ? void 0 : fileMatch2[1]) {
          let short = fileMatch2[1].substring(fileMatch2[1].lastIndexOf("/") + 1);
          const q = short.indexOf("?");
          if (q !== -1) short = short.substring(0, q);
          caller += ` (${short})`;
        }
        return caller;
      }
      const fileMatch = line.match(/at\s+([^\s(]+:\d+:\d+)/);
      if (fileMatch == null ? void 0 : fileMatch[1]) {
        let short = fileMatch[1].substring(fileMatch[1].lastIndexOf("/") + 1);
        const q = short.indexOf("?");
        if (q !== -1) short = short.substring(0, q);
        return short;
      }
    } catch (_) {
    }
    return "unknown";
  }
  function getTimestamp() {
    const n = /* @__PURE__ */ new Date();
    return [n.getHours(), n.getMinutes(), n.getSeconds()].map((v) => String(v).padStart(2, "0")).join(":") + "." + String(n.getMilliseconds()).padStart(3, "0");
  }
  const LOG = function(...args) {
    if (debugMode === 0) return;
    if (debugMode === 1) {
      console.log("%c GG %c \u{1F680}", BADGE, RESET, ...args);
      return;
    }
    console.log("%c GG %c \u{1F680} [" + getCallerInfo() + "]", BADGE, RESET, ...args);
  };
  LOG.debug = function(...args) {
    if (debugMode === 0) return;
    if (debugMode === 1) {
      console.log("%c GG %c \u{1F50D}", BADGE_DEBUG, RESET, ...args);
      return;
    }
    console.log("%c GG %c \u{1F50D} [" + getTimestamp() + "] [" + getCallerInfo() + "]", BADGE_DEBUG, RESET, ...args);
  };
  LOG.info = function(...args) {
    if (debugMode === 0) return;
    if (debugMode === 1) {
      console.log("%c GG %c \u2139\uFE0F", BADGE_INFO, RESET, ...args);
      return;
    }
    console.log("%c GG %c \u2139\uFE0F [" + getTimestamp() + "] [" + getCallerInfo() + "]", BADGE_INFO, RESET, ...args);
  };
  LOG.warn = function(...args) {
    if (debugMode === 0) return;
    if (debugMode === 1) {
      console.warn("%c GG %c \u26A0\uFE0F", BADGE_WARN, RESET, ...args);
      return;
    }
    console.warn("%c GG %c \u26A0\uFE0F [" + getTimestamp() + "] [" + getCallerInfo() + "]", BADGE_WARN, RESET, ...args);
  };
  LOG.success = function(...args) {
    if (debugMode === 0) return;
    if (debugMode === 1) {
      console.log("%c GG %c \u2705", BADGE_SUCCESS, RESET, ...args);
      return;
    }
    console.log("%c GG %c \u2705 [" + getTimestamp() + "] [" + getCallerInfo() + "]", BADGE_SUCCESS, RESET, ...args);
  };
  LOG.error = function(...args) {
    try {
      const decoded = args.map((arg) => {
        try {
          if (arg instanceof Error) return { type: "Error", name: arg.name, message: arg.message, stack: arg.stack };
          if (arg && typeof arg === "object") {
            const a = arg;
            if (a["description"]) return { type: "ShopifyError", description: a["description"], message: a["message"] || a["description"], status: a["status"], raw: arg };
            if (a["message"]) return { type: "ErrorObject", message: a["message"], raw: arg };
            if (typeof a["status"] === "number" && typeof a["statusText"] === "string") return { type: "FetchResponse", status: a["status"], statusText: a["statusText"], url: a["url"] };
          }
          return arg;
        } catch (_) {
          return arg;
        }
      });
      console.error("%c GG %c \u274C [" + getTimestamp() + "] [" + getCallerInfo() + "]", BADGE_ERROR, RESET, ...decoded);
    } catch (_) {
      try {
        console.error("%c GG %c \u274C", BADGE_ERROR, RESET, ...args);
      } catch (_2) {
        console.error(...args);
      }
    }
  };
  LOG.time = function(label) {
    if (debugMode === 0) return;
    timers.set(label, performance.now());
    if (debugMode === 2) console.log("%c GG %c \u23F1\uFE0F [" + getCallerInfo() + '] Timer "' + label + '" avviato', BADGE_TIME, RESET);
  };
  LOG.timeEnd = function(label) {
    if (debugMode === 0) return;
    const start = timers.get(label);
    if (!start) {
      if (debugMode >= 1) console.warn('%c GG %c \u26A0\uFE0F Timer "' + label + '" non trovato', BADGE_WARN, RESET);
      return;
    }
    const elapsed = performance.now() - start;
    timers.delete(label);
    const color = elapsed >= 500 ? "#ef4444" : elapsed >= 100 ? "#eab308" : "#22c55e";
    if (debugMode === 1) {
      console.log("%c GG %c \u23F1\uFE0F %c" + label + ": " + elapsed.toFixed(2) + "ms", BADGE_TIME, RESET, "color:" + color + ";font-weight:bold;");
      return;
    }
    console.log("%c GG %c \u23F1\uFE0F %c[" + getTimestamp() + "] [" + getCallerInfo() + "] " + label + ": " + elapsed.toFixed(2) + "ms", BADGE_TIME, RESET, "color:" + color + ";font-weight:bold;");
  };
  LOG.group = function(label) {
    if (debugMode === 0) return;
    openGroups++;
    if (debugMode === 1) {
      console.groupCollapsed("%c GG %c \u{1F4C1} " + label, BADGE_GROUP, RESET);
      return;
    }
    console.groupCollapsed("%c GG %c \u{1F4C1} [" + getTimestamp() + "] [" + getCallerInfo() + "] " + label, BADGE_GROUP, RESET);
  };
  LOG.groupEnd = function() {
    if (debugMode === 0 || openGroups <= 0) return;
    console.groupEnd();
    openGroups--;
  };
  LOG.table = function(data, label) {
    if (debugMode === 0) return;
    if (label) {
      if (debugMode === 2) console.log("%c GG %c \u{1F4CA} [" + getCallerInfo() + "] " + label, BADGE_TABLE, RESET);
      else console.log("%c GG %c \u{1F4CA} " + label, BADGE_TABLE, RESET);
    }
    console.table(data);
  };
  LOG.trace = function(...args) {
    if (debugMode === 0) return;
    if (debugMode === 1) {
      console.log("%c GG %c \u{1F50E}", BADGE_TRACE, RESET, ...args);
      console.trace();
      return;
    }
    console.log("%c GG %c \u{1F50E} [" + getTimestamp() + "]", BADGE_TRACE, RESET, ...args);
    console.trace();
  };
  LOG.closeAllGroups = function() {
    while (openGroups > 0) {
      console.groupEnd();
      openGroups--;
    }
  };
  window.LOG = LOG;
})();
window.addEventListener("error", (event) => {
  var _a2, _b, _c;
  (_b = (_a2 = window.LOG) == null ? void 0 : _a2.closeAllGroups) == null ? void 0 : _b.call(_a2);
  const msg = `[GlobalError] ${event.message}`;
  const detail = `${event.filename}:${event.lineno}:${event.colno}`;
  ((_c = window.LOG) == null ? void 0 : _c.error) ? window.LOG.error(msg, detail, event.error) : console.error(msg, detail, event.error);
});
window.addEventListener("unhandledrejection", (event) => {
  var _a2, _b, _c;
  (_b = (_a2 = window.LOG) == null ? void 0 : _a2.closeAllGroups) == null ? void 0 : _b.call(_a2);
  ((_c = window.LOG) == null ? void 0 : _c.error) ? window.LOG.error("[UnhandledRejection]", event.reason) : console.error("[UnhandledRejection]", event.reason);
});
const BREAKPOINT_CSS_VARIABLES = {
  sm: "--screen-sm",
  md: "--screen-md",
  lg: "--screen-lg",
  xl: "--screen-xl",
  xxl: "--screen-2xl"
};
const breakpointCache = /* @__PURE__ */ new Map();
function getCssVariableValue(name) {
  if (typeof window === "undefined") return "";
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
function resolveCssBreakpoint(name, fallback = "") {
  if (breakpointCache.has(name)) return breakpointCache.get(name);
  const varName = BREAKPOINT_CSS_VARIABLES[name];
  if (!varName) return fallback;
  const value = getCssVariableValue(varName) || fallback;
  if (value) breakpointCache.set(name, value);
  return value;
}
if (!window.theme.breakpoints) {
  window.theme.breakpoints = {
    get(name, fallback = "") {
      return resolveCssBreakpoint(name, fallback);
    },
    matchMedia(name, options = {}) {
      if (typeof window === "undefined" || !window.matchMedia) return null;
      const { type = "min", fallback = "" } = options;
      const value = resolveCssBreakpoint(name, fallback);
      if (!value) return null;
      return window.matchMedia(`(${type}-width: ${value})`);
    }
  };
}
async function themeComponent(url, lazyLoad = true, checkDom = false) {
  const tagName = url.replace(/.*\//, "").replace(/\?.*/, "").replace("wc-", "").replace(".js", "");
  const className = "Wc" + tagName.replace(/-([a-z])/g, (_, g) => g.toUpperCase()).replace(/^./, (g) => g.toUpperCase());
  if (window[className] !== void 0) return;
  if (checkDom && document.querySelector(tagName) === null) return;
  const load = () => import(url).catch((e) => {
    var _a2;
    ((_a2 = window.LOG) == null ? void 0 : _a2.error) ? window.LOG.error(`[themeComponent] Errore caricamento ${tagName}:`, e) : console.error(`[themeComponent] Errore caricamento ${tagName}:`, e);
  });
  lazyLoad ? load() : await load();
}
window.themeComponent = themeComponent;
